import { Component } from '@angular/core'

@Component({
  selector: '[app-modal-footer]',
  host: {
    class: 'modal-footer',
  },
  template: '<ng-content></ng-content>',
  styles: `
    :host {
        width: 100%;
        display: flex;
        justify-content: end;
        gap: 0.5rem;
    }
  `,
})
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class ModalFooterComponent {}
